export default function copyToClipboard(text) {
  navigator.clipboard.writeText(text);
}
